import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="global-footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} AI MeetBot. All rights reserved. | <Link to="/privacy-policy">Privacy Policy</Link></p>
            </div>
        </footer>
    );
};

export default Footer;
